import { render } from "./FullscreenButton.vue?vue&type=template&id=5a5ebf7a"
import script from "./FullscreenButton.vue?vue&type=script&lang=ts"
export * from "./FullscreenButton.vue?vue&type=script&lang=ts"

import "./FullscreenButton.vue?vue&type=style&index=0&id=5a5ebf7a&lang=scss"
script.render = render

export default script